/* Nourished chat: eigen chatwidget, praat met de nourished-chat-backend (zie snippets/nourished-chat.liquid). */
(function () {
  'use strict';

  var root = document.getElementById('nourished-chat');
  var cfgEl = document.getElementById('nourished-chat-config');
  if (!root || !cfgEl || root.getAttribute('data-nc')) return;
  root.setAttribute('data-nc', '1');

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var API = String(cfg.apiUrl || '').replace(/\/+$/, '');
  if (!/^https:\/\//.test(API) || !window.fetch || !window.Promise) return;

  var EN = /^en/i.test(cfg.locale || '');
  var KEY = 'nourished-chat:v1';
  var MAX_FILES = 3;
  var MAX_SIZE = 10 * 1024 * 1024;
  var BACKOFF = [1, 2, 5, 10, 30];
  var STEADY = 5000;
  var MAX_AGE = 30 * 864e5;
  var IMG = /^image\/(jpeg|png|webp|gif)$/;
  var SAFE = /^(image\/(jpeg|png|webp|gif)|application\/pdf)$/;
  var ACCEPT = 'image/jpeg,image/png,image/webp,image/gif,application/pdf,.pdf';
  var NS = 'http://www.w3.org/2000/svg';
  var LINK_RE = /\bhttps?:\/\/[^\s<>"'`]+/gi;
  /* Zelfde regels als de backend bij POST /v1/conversations. */
  var ORDER_RE = /^#?[A-Za-z0-9][A-Za-z0-9 _\/-]{0,39}$/;
  var OWN = /@nourished\.nl$/i;
  var noop = function () {};

  var T = EN ? {
    launch: 'Chat with Team Nourished', one: 'new message', many: 'new messages',
    team: 'Team Nourished', sub: 'We usually reply within minutes',
    close: 'Close chat', more: 'More options', end: 'End conversation',
    hello: 'Hi! 👋 How can we help you?', helloSub: 'Pick a topic or type your question below.',
    topics: ['What is the status of my order?', 'I have a question about a product', 'I have a question about {p}',
      "I'm curious about a product. Can you tell me more about it?", "I'd like to return or exchange something", 'Something else'],
    orderHint: 'Have your order number handy? Then we can help you faster.',
    gate: 'Before we start this chat, could you share a few details?', question: 'Your question:',
    start: 'Start chat', back: 'Back',
    firstName: 'First name', lastName: 'Last name', email: 'Email address',
    orderNumber: 'Order number', optional: '(optional)',
    ph: 'Type your message…', send: 'Send', attach: 'Add attachment', remove: 'Remove',
    sending: 'Sending…', failed: 'Not sent', retry: 'Try again',
    today: 'Today', yesterday: 'Yesterday', typing: 'Team Nourished is typing…',
    away: "We're away for a moment. Leave your email address and we'll send our reply by email.",
    awayKnown: "We're away for a moment. We'll send our reply to {email}.", otherMail: 'Different email address?',
    save: 'Save', closed: 'This conversation has ended', restart: 'Start a new conversation',
    open: 'Open', lbClose: 'Close image',
    sys: { contact_saved: "Thanks! We'll email you our reply.", closed: 'This conversation has ended.' },
    err: {
      validation_failed: "That didn't quite work. Please check your message and try again.",
      invalid_token: 'This conversation has expired. Feel free to start a new one.',
      forbidden_origin: "The chat isn't available on this page right now.",
      not_found: 'This attachment is no longer available.',
      conversation_closed: 'This conversation has already ended. Start a new one to keep chatting.',
      attachment_in_use: 'This attachment has already been sent.',
      file_too_large: 'This file is larger than 10 MB. Please choose a smaller one.',
      payload_too_large: 'Your message is too long. Please shorten it and try again.',
      unsupported_type: "We can't receive this type of file. Please send a photo or PDF.",
      rate_limited: "You're sending a lot of messages at once. Please try again in a few minutes.",
      mail_unavailable: "We couldn't send your message just now. Please try again shortly.",
      internal: 'Something went wrong on our side. Please try again shortly.',
      network: 'No connection. Check your internet and try again.',
      too_many: 'You can attach up to 3 files per message.',
      bad_email: 'Please enter a valid email address.',
      need_firstName: 'Please enter your first name.',
      need_lastName: 'Please enter your last name.',
      need_email: 'Please enter your email address.',
      own_email: 'Please use your own email address, not a Nourished one.',
      bad_order: 'Please check your order number, e.g. #1234.',
      contact: "That didn't quite work. Please check your details and try again."
    }
  } : {
    launch: 'Chat met Team Nourished', one: 'nieuw bericht', many: 'nieuwe berichten',
    team: 'Team Nourished', sub: 'We reageren meestal binnen minuten',
    close: 'Chat sluiten', more: 'Meer opties', end: 'Gesprek beëindigen',
    hello: 'Hoi! 👋 Waar kunnen we je mee helpen?', helloSub: 'Kies een onderwerp of typ hieronder je vraag.',
    topics: ['Wat is de status van mijn order?', 'Ik heb een vraag over een product', 'Ik heb een vraag over {p}',
      'Ik ben nieuwsgierig naar een product. Kun je me er meer over vertellen?', 'Ik wil iets retourneren of ruilen', 'Iets anders'],
    orderHint: 'Heb je je ordernummer bij de hand? Dan helpen we je sneller.',
    gate: 'Voordat we deze chat starten, zou je vast deze informatie kunnen geven?', question: 'Je vraag:',
    start: 'Chat starten', back: 'Terug',
    firstName: 'Voornaam', lastName: 'Achternaam', email: 'E-mailadres',
    orderNumber: 'Ordernummer', optional: '(optioneel)',
    ph: 'Typ je bericht…', send: 'Versturen', attach: 'Bijlage toevoegen', remove: 'Verwijderen',
    sending: 'Versturen…', failed: 'Niet verstuurd', retry: 'Opnieuw proberen',
    today: 'Vandaag', yesterday: 'Gisteren', typing: 'Team Nourished is aan het typen…',
    away: 'We zijn er even niet. Laat je e-mailadres achter, dan sturen we ons antwoord per mail.',
    awayKnown: 'We zijn er even niet. We sturen ons antwoord naar {email}.', otherMail: 'Ander e-mailadres?',
    save: 'Opslaan', closed: 'Dit gesprek is afgesloten', restart: 'Nieuw gesprek starten',
    open: 'Openen', lbClose: 'Afbeelding sluiten',
    sys: { contact_saved: 'Dank je! We sturen ons antwoord naar je e-mail.', closed: 'Dit gesprek is afgesloten.' },
    err: {
      validation_failed: 'Dat lukte niet helemaal. Controleer je bericht en probeer het opnieuw.',
      invalid_token: 'Dit gesprek is verlopen. Je kunt gewoon een nieuw gesprek starten.',
      forbidden_origin: 'De chat is op deze pagina even niet beschikbaar.',
      not_found: 'Deze bijlage is niet meer beschikbaar.',
      conversation_closed: 'Dit gesprek is al afgesloten. Start een nieuw gesprek om verder te praten.',
      attachment_in_use: 'Deze bijlage is al verstuurd.',
      file_too_large: 'Dit bestand is groter dan 10 MB. Kies een kleiner bestand.',
      payload_too_large: 'Je bericht is te lang. Maak het wat korter en probeer het opnieuw.',
      unsupported_type: 'Dit soort bestand kunnen we niet ontvangen. Stuur een foto of pdf.',
      rate_limited: 'Je stuurt veel berichten kort na elkaar. Probeer het over een paar minuten opnieuw.',
      mail_unavailable: 'Je bericht kon even niet worden verstuurd. Probeer het zo nog eens.',
      internal: 'Er ging iets mis aan onze kant. Probeer het zo nog eens.',
      network: 'Geen verbinding. Controleer je internet en probeer het opnieuw.',
      too_many: 'Je kunt maximaal 3 bijlagen per bericht meesturen.',
      bad_email: 'Vul een geldig e-mailadres in.',
      need_firstName: 'Vul je voornaam in.',
      need_lastName: 'Vul je achternaam in.',
      need_email: 'Vul je e-mailadres in.',
      own_email: 'Gebruik je eigen e-mailadres, niet een adres van Nourished.',
      bad_order: 'Controleer je ordernummer, bijvoorbeeld #1234.',
      contact: 'Dat lukte niet helemaal. Controleer je gegevens en probeer het opnieuw.'
    }
  };

  /* Bevestiging na ACK_MS zonder teamantwoord, in de taal van het IP-land (st.cc). */
  var ACK = {
    nl: 'Bedankt voor je bericht! We zoeken het even voor je uit en reageren zo snel mogelijk.',
    de: 'Danke für deine Nachricht! Wir schauen uns das kurz für dich an und melden uns so schnell wie möglich.',
    fr: 'Merci pour votre message\u00a0! Nous regardons cela pour vous et revenons vers vous au plus vite.',
    en: "Thanks for your message! We're looking into it and will get back to you as soon as possible."
  };
  var ACK_MS = 10000;

  var I = {
    x: 'M6 6l12 12|M18 6L6 18',
    send: 'M12 19V5|M5.5 11.5L12 5l6.5 6.5',
    clip: 'M21.4 11.1l-9.2 9.2a6 6 0 0 1-8.5-8.5l9.2-9.2a4 4 0 0 1 5.7 5.7l-9.2 9.2a2 2 0 0 1-2.8-2.8l8.5-8.5',
    more: 'M12 5.5h.01|M12 12h.01|M12 18.5h.01',
    file: 'M14 2.5H6.5a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8z|M14 2.5V8h5.5',
    arrow: 'M5 12h14|M13 6l6 6-6 6',
    end: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4|M16 17l5-5-5-5|M21 12H9',
    mail: 'M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z|M22 7l-10 6.5L2 7'
  };
  var BUBBLE = 'M12 4h8a9 9 0 0 1 9 9v1.5a9 9 0 0 1-9 9h-5.2l-5.6 4.2a1 1 0 0 1-1.6-.8v-4.6A9 9 0 0 1 3 14.5V13a9 9 0 0 1 9-9z';
  /* De n uit het Nourished-logo, viewBox 0 0 216 221. */
  var LOGO_N = 'M0.7 220.3C0.3 220.0 0.0 172.0 0.0 113.8L0.0 8.0 L38.5 8.0L77.0 8.0 L77.0 27.1L77.0 46.3 L87.1 35.6C109.7 11.8 132.8 -0.0 156.7 -0.0C168.7 -0.0 178.3 2.1 188.8 7.2C199.0 12.0 208.3 20.7 212.6 29.6L215.5 35.5 L215.8 128.2L216.0 221.0 L178.0 221.0L140.0 221.0 L139.8 127.2C139.5 38.4 139.4 33.3 137.6 29.2C132.4 17.2 120.5 16.0 106.3 25.9C100.1 30.3 88.4 42.2 80.3 52.4L77.0 56.5 L77.0 138.8L77.0 221.0 L39.2 221.0C18.4 221.0 1.0 220.7 0.7 220.3Z';

  /* Gegevensstap; k is ook de sleutel in st.contact en in de body van POST /v1/conversations. */
  var FIELDS = [
    { k: 'firstName', ac: 'given-name', max: 60 },
    { k: 'lastName', ac: 'family-name', max: 80 },
    { k: 'email', ac: 'email', max: 254, type: 'email' },
    { k: 'orderNumber', ac: 'off', max: 40, opt: true }
  ];

  /* ---------- state ---------- */

  var st = load();
  var conv = null;
  var msgs = [];
  var byId = {};
  var local = [];
  var files = [];
  var blobs = {};
  var shown = [];
  var topic = null;
  /* Tekst van het eerste bericht zolang de gegevensstap open staat; bijlagen blijven in files. */
  var pend = null;
  var seq = 0;
  var isOpen = false;
  var P = null;
  var creating = null;
  var ctl = null;
  var fails = 0;
  var retryT = 0;
  var pollT = 0;
  var flashT = 0;
  var typT = 0;
  var ackT = 0;
  var ccQ = 0;
  /* Getoonde bevestigingen { k, t, l }; blijven na forget() in het geheugen voor het afgesloten-scherm. */
  var acks = Array.isArray(st.acks) ? st.acks : [];
  var drawQ = 0;
  var mq = window.matchMedia ? window.matchMedia('(max-width: 639px)') : { matches: false };

  function load() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      if (v && typeof v === 'object' && Date.now() - v.t < MAX_AGE) return v;
      localStorage.removeItem(KEY);
    } catch (e) { /* opslag geblokkeerd */ }
    return {};
  }
  function save() {
    st.t = Date.now();
    try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) { /* opslag vol of geblokkeerd */ }
  }

  /* ---------- dom helpers ---------- */

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function at(e, o) { for (var k in o) e.setAttribute(k, o[k]); return e; }
  function kids(e) { for (var i = 1; i < arguments.length; i++) if (arguments[i]) e.appendChild(arguments[i]); return e; }
  function ico(d, cls) {
    var s = at(document.createElementNS(NS, 'svg'), { viewBox: '0 0 24 24', 'aria-hidden': 'true', focusable: 'false', 'class': 'nc-i' + (cls ? ' ' + cls : '') });
    d.split('|').forEach(function (p) { var q = document.createElementNS(NS, 'path'); q.setAttribute('d', p); s.appendChild(q); });
    return s;
  }
  function btn(cls, label, icon) {
    var b = at(el('button', cls), { type: 'button' });
    if (label) b.setAttribute('aria-label', label);
    if (icon) b.appendChild(ico(icon));
    return b;
  }
  function logo(o) { o = o || {}; o.d = LOGO_N; return at(document.createElementNS(NS, 'path'), o); }
  function av(cls) {
    var s = at(document.createElementNS(NS, 'svg'), { viewBox: '0 0 216 221', 'aria-hidden': 'true', focusable: 'false' });
    return kids(at(el('span', 'nc-av ' + cls), { 'aria-hidden': 'true' }), kids(s, logo()));
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function hhmm(d) { return pad(d.getHours()) + ':' + pad(d.getMinutes()); }
  function dayKey(d) { return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate(); }
  function dayLabel(d) {
    var a = new Date(); a.setHours(0, 0, 0, 0);
    var b = new Date(d.getTime()); b.setHours(0, 0, 0, 0);
    var n = Math.round((a - b) / 864e5);
    if (n === 0) return T.today;
    if (n === 1) return T.yesterday;
    var o = { weekday: 'long', day: 'numeric', month: 'long' };
    if (d.getFullYear() !== a.getFullYear()) o.year = 'numeric';
    return d.toLocaleDateString(EN ? 'en-GB' : 'nl-NL', o);
  }
  function fmtSize(n) {
    return n >= 1048576 ? (n / 1048576).toFixed(1).replace('.', EN ? '.' : ',') + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB';
  }
  function okMail(v) { return v.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  function okType(f) { return IMG.test(f.type) || /^application\/pdf$/.test(f.type) || /\.pdf$/i.test(f.name); }
  function parse(t) { try { return t ? JSON.parse(t) : {}; } catch (e) { return {}; } }

  function linkify(node, text) {
    var last = 0, m;
    LINK_RE.lastIndex = 0;
    while ((m = LINK_RE.exec(text))) {
      var u = m[0].replace(/[.,!?;:)\]]+$/, ''), href = '';
      try { var p = new window.URL(u); if (p.protocol === 'https:' || p.protocol === 'http:') href = p.href; } catch (e) { /* geen geldige url */ }
      if (!href) continue;
      if (m.index > last) node.appendChild(document.createTextNode(text.slice(last, m.index)));
      node.appendChild(at(el('a', 'nc-link', u), { href: href, target: '_blank', rel: 'noopener noreferrer nofollow' }));
      last = LINK_RE.lastIndex = m.index + u.length;
    }
    if (last < text.length) node.appendChild(document.createTextNode(text.slice(last)));
    return node;
  }

  /* ---------- api ---------- */

  function err(code, status) { var e = new Error(code); e.code = code; e.status = status; return e; }
  /* Retry-After alleen als seconden; afgekapt zodat setTimeout niet overloopt. */
  function after(r) {
    var s = r.status === 429 ? parseInt(r.headers.get('Retry-After'), 10) : 0;
    return s > 0 ? Math.min(s, 3600) : 0;
  }
  function code(j, s) {
    return (j && j.error && j.error.code) || (s === 429 ? 'rate_limited' : s === 401 ? 'invalid_token' : s >= 500 ? 'internal' : 'validation_failed');
  }
  function errText(e) { return T.err[e && e.code] || T.err.internal; }
  function auth() { return st.token ? { Authorization: 'Bearer ' + st.token } : {}; }
  function cpath(p) { return '/v1/conversations/' + encodeURIComponent(st.id) + (p || ''); }

  function api(method, path, body) {
    var h = auth();
    if (body) h['Content-Type'] = 'application/json';
    return fetch(API + path, { method: method, headers: h, body: body ? JSON.stringify(body) : undefined, credentials: 'omit', cache: 'no-store' })
      .then(function (r) {
        return r.text().then(function (t) {
          var j = parse(t);
          if (!r.ok) { var e = err(code(j, r.status), r.status); e.after = after(r); throw e; }
          return j;
        });
      }, function () { throw err('network'); });
  }

  /* IP-land via Shopify, eenmalig en lui; bij een fout blijft de widgettaal gelden. */
  function country() {
    if (st.cc || ccQ) return;
    ccQ = 1;
    try {
      var c = window.AbortController ? new AbortController() : null, t = c && setTimeout(function () { c.abort(); }, 3000);
      fetch('/browsing_context_suggestions.json', { credentials: 'same-origin', signal: c ? c.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var h = String((j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || '').toUpperCase();
          if (/^[A-Z]{2}$/.test(h)) { st.cc = h; save(); }
        })
        .catch(noop)
        .then(function () { clearTimeout(t); });
    } catch (e) { /* geen land: widgettaal */ }
  }
  function lang() {
    var c = st.cc;
    return !c ? (EN ? 'en' : 'nl') : /^(NL|BE|SR|AW|CW|SX)$/.test(c) ? 'nl' : /^(DE|AT|CH|LI|LU)$/.test(c) ? 'de' : /^(FR|MC)$/.test(c) ? 'fr' : 'en';
  }

  function pageInfo() {
    var p = { url: (location.origin + location.pathname).slice(0, 500), title: document.title.slice(0, 200) };
    if (cfg.product && cfg.product.title) p.productTitle = String(cfg.product.title).slice(0, 200);
    return p;
  }

  function ensureConv() {
    if (st.id) return Promise.resolve();
    if (creating) return creating;
    var c = st.contact || {}, k = cfg.customer, body = { locale: cfg.locale || 'nl', page: pageInfo(), website: P ? P.hp.value : '' };
    FIELDS.forEach(function (f) { if (c[f.k]) body[f.k] = c[f.k]; });
    if (k && (k.name || k.email)) body.customer = { name: k.name || undefined, email: k.email || undefined };
    if (topic) body.topic = topic;
    creating = api('POST', '/v1/conversations', body).then(function (r) {
      creating = null;
      st.id = r.conversation.id;
      st.token = r.sessionToken;
      save();
      merge(r.conversation);
      live();
    }, function (e) { creating = null; e.contact = e.status === 400; throw e; });
    return creating;
  }

  function refresh() {
    if (!st.id) return Promise.resolve();
    return api('GET', cpath()).then(function (r) { merge(r.conversation); }, function (e) {
      if (e.code === 'invalid_token' || e.status === 404) expire();
      throw e;
    });
  }

  function upload(a) {
    if (a.id) return Promise.resolve(a.id);
    if (a.p) return a.p;
    a.p = new Promise(function (res, rej) {
      var x = a.xhr = new XMLHttpRequest(), fd = new FormData();
      x.open('POST', API + cpath('/attachments'));
      x.setRequestHeader('Authorization', 'Bearer ' + st.token);
      x.upload.onprogress = function (e) { if (e.lengthComputable) prog(a, e.loaded / e.total); };
      x.onload = function () {
        var j = parse(x.responseText), att = j.attachment;
        if (x.status >= 200 && x.status < 300 && att && att.id) {
          a.id = att.id;
          blobs[a.id] = a.url;
          prog(a, 1);
          res(a.id);
        } else rej(err(code(j, x.status), x.status));
      };
      x.onerror = function () { rej(err('network')); };
      x.onabort = function () { rej(err('aborted')); };
      fd.append('file', a.file, a.file.name);
      x.send(fd);
    }).then(null, function (e) { a.p = a.xhr = null; prog(a, 0); throw e; });
    return a.p;
  }

  function blobOf(a) {
    if (blobs[a.id]) return Promise.resolve(blobs[a.id]);
    if (!/^\/v1\/conversations\//.test(a.url || '')) return Promise.reject(err('not_found'));
    var p = fetch(API + a.url, { headers: auth(), credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw err(r.status === 404 || r.status === 401 ? 'not_found' : 'internal');
      var t = (r.headers.get('Content-Type') || '').split(';')[0].trim().toLowerCase();
      if (!SAFE.test(t)) throw err('unsupported_type');
      return r.blob().then(function (b) { return new Blob([b], { type: t }); });
    }).then(function (b) { return (blobs[a.id] = URL.createObjectURL(b)); });
    blobs[a.id] = p;
    p.catch(function () { if (blobs[a.id] === p) delete blobs[a.id]; });
    return p;
  }

  /* ---------- live: SSE via fetch ---------- */

  function live() {
    clearTimeout(retryT);
    if (!st.id || ctl || document.hidden || (conv && conv.state === 'closed')) return;
    if (!window.AbortController || !window.TextDecoder) { startPoll(); return; }
    var c = ctl = new AbortController(), h = auth(), t0 = 0, okT = 0;
    /* Pas een stream die STEADY ms openblijft telt als gelukt; een proxy die direct sluit valt onder de backoff. */
    function steady() { clearTimeout(okT); return t0 > 0 && Date.now() - t0 >= STEADY; }
    h.Accept = 'text/event-stream';
    fetch(API + cpath('/events') + (st.last ? '?after=' + encodeURIComponent(st.last) : ''), { headers: h, signal: c.signal, credentials: 'omit', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok || !r.body) return r.text().then(function (t) { var e = err(code(parse(t), r.status), r.status); e.after = after(r); throw e; });
        t0 = Date.now();
        okT = setTimeout(function () { if (ctl === c) { fails = 0; stopPoll(); } }, STEADY);
        return pump(r.body.getReader());
      })
      .then(function () {
        var ok = steady();
        if (ctl !== c) return;
        ctl = null;
        if (ok) { fails = 0; retryT = setTimeout(live, 1000); } else retry();
      }, function (e) {
        var ok = steady();
        if (ctl !== c) return;
        ctl = null;
        if (ok) fails = 0;
        if (e.code === 'invalid_token') return expire();
        if (e.code === 'invalid_cursor') { st.last = null; return refresh().then(live, retry); }
        retry(e);
      });
  }

  function pump(reader) {
    var dec = new TextDecoder(), buf = '';
    return (function next() {
      return reader.read().then(function (r) {
        if (r.done) return;
        buf += dec.decode(r.value, { stream: true }).replace(/\r\n?/g, '\n');
        var i;
        while ((i = buf.indexOf('\n\n')) >= 0) {
          sse(buf.slice(0, i));
          buf = buf.slice(i + 2);
        }
        return next();
      });
    })();
  }

  function sse(block) {
    var ev = 'message', data = [];
    block.split('\n').forEach(function (l) {
      if (!l || l.charAt(0) === ':') return;
      var i = l.indexOf(':'), f = i < 0 ? l : l.slice(0, i), v = i < 0 ? '' : l.slice(i + 1).replace(/^ /, '');
      if (f === 'event') ev = v;
      else if (f === 'data') data.push(v);
    });
    if (!data.length) return;
    var d = parse(data.join('\n'));
    if (ev === 'message') {
      addMsgs([d]);
      if (d.author === 'system' && d.systemCode === 'closed') setState('closed');
    } else if (ev === 'state' && d.state) setState(d.state);
  }

  function retry(e) {
    var d = BACKOFF[Math.min(fails, BACKOFF.length - 1)] + ((e && e.after) || 0);
    fails++;
    if (fails >= 3) startPoll();
    retryT = setTimeout(live, d * 1000);
  }
  function startPoll() {
    if (!pollT) pollT = setInterval(function () { if (!document.hidden) refresh().catch(noop); }, 15000);
  }
  function stopPoll() { clearInterval(pollT); pollT = 0; }
  function stopLive() {
    clearTimeout(retryT);
    stopPoll();
    if (ctl) { var c = ctl; ctl = null; c.abort(); }
  }

  /* ---------- model ---------- */

  function merge(c) {
    if (!c) return;
    conv = { state: c.state, contact: c.contact || {} };
    addMsgs(c.messages || []);
    st.last = msgs.length ? msgs[msgs.length - 1].id : null;
    save();
    setState(c.state);
  }

  function setState(s) {
    if (!conv) conv = { state: s, contact: {} };
    conv.state = s;
    if (s === 'closed') forget();
    draw();
  }

  /* Afgesloten: token en contact weg uit opslag. Het afgesloten-scherm leeft
     alleen nog in het geheugen; na herladen volgt het welkomstscherm. */
  function forget() {
    stopLive();
    stopTyping();
    clearTimeout(ackT);
    ackT = 0;
    if (!st.id && !st.token && !st.contact) return;
    st = { open: st.open, seen: st.seen, cc: st.cc };
    save();
  }

  function addMsgs(list) {
    var add = 0, before = unread();
    list.forEach(function (m) {
      if (!m || !m.id || byId[m.id]) return;
      byId[m.id] = m;
      msgs.push(m);
      add++;
      if (m.author !== 'customer') return;
      m.rx = Date.now();
      for (var i = 0; i < local.length; i++) {
        var l = local[i];
        if (l.status === 'sending' && l.text === (m.text || '') && l.files.length === (m.attachments || []).length) { local.splice(i, 1); break; }
      }
    });
    if (!add) return;
    msgs.sort(function (a, b) { return a.id < b.id ? -1 : a.id > b.id ? 1 : 0; });
    st.last = msgs[msgs.length - 1].id;
    if (isOpen && !document.hidden) st.seen = st.last;
    save();
    badge(unread() > before);
    draw();
  }

  function unread() {
    var n = 0, s = st.seen || '';
    msgs.forEach(function (m) { if (m.author === 'team' && m.id > s) n++; });
    return n;
  }

  function badge(bump) {
    var n = isOpen && !document.hidden ? 0 : unread();
    P0.badge.textContent = n > 9 ? '9+' : String(n);
    root.classList.toggle('nc-unread', n > 0);
    P0.btn.setAttribute('aria-label', n ? T.launch + ' (' + n + ' ' + (n === 1 ? T.one : T.many) + ')' : T.launch);
    if (bump && n) {
      P0.badge.classList.remove('nc-bump');
      void P0.badge.offsetWidth;
      P0.badge.classList.add('nc-bump');
    }
  }

  function markSeen() {
    if (st.last && st.seen !== st.last) { st.seen = st.last; save(); }
    badge();
  }

  function expire() {
    var wasOpen = isOpen;
    reset();
    if (wasOpen) flash(T.err.invalid_token);
  }

  function reset() {
    stopLive();
    stopTyping();
    clearTimeout(ackT);
    ackT = 0;
    st = { open: st.open, cc: st.cc };
    save();
    acks = [];
    conv = null;
    msgs = [];
    byId = {};
    local = [];
    topic = null;
    Object.keys(blobs).forEach(function (k) { if (typeof blobs[k] === 'string') URL.revokeObjectURL(blobs[k]); });
    blobs = {};
    files.forEach(function (a) { a.id = a.p = null; });
    if (P) {
      shown.forEach(function (s) { s.node.remove(); });
      shown = [];
      prefill();
      pickTopic(null);
    }
    badge();
    draw();
  }

  /* ---------- sending ---------- */

  function check(k, v) {
    if (!v) return k === 'orderNumber' ? '' : T.err['need_' + k];
    if (k === 'email') return !okMail(v) ? T.err.bad_email : OWN.test(v) ? T.err.own_email : '';
    if (k === 'orderNumber' && !ORDER_RE.test(v)) return T.err.bad_order;
    return '';
  }

  function takeContact() {
    var c = {}, bad = null;
    FIELDS.forEach(function (f) {
      var v = P.f[f.k].in.value.trim().slice(0, f.max), msg = check(f.k, v);
      fieldErr(f.k, msg);
      if (msg && !bad) bad = P.f[f.k].in;
      if (v) c[f.k] = v;
    });
    if (bad) {
      bad.focus();
      return false;
    }
    st.contact = c;
    save();
    return true;
  }
  function known() {
    var c = st.contact;
    return !!c && FIELDS.every(function (f) { return !check(f.k, String(c[f.k] || '')); });
  }

  function send() {
    var text = P.ta.value.trim();
    if (pend != null || (!text && !files.length) || (conv && conv.state === 'closed')) return;
    if (formOn()) openGate(text);
    else post(text);
  }

  function post(text) {
    var lm = { n: ++seq, author: 'customer', text: text, files: files, createdAt: new Date().toISOString(), status: 'sending' };
    files = [];
    P.ta.value = '';
    grow();
    drawFiles();
    P.hint.hidden = true;
    local.push(lm);
    deliver(lm);
  }

  function deliver(lm) {
    lm.status = 'sending';
    draw();
    ensureConv().then(function () {
      return Promise.all(lm.files.map(upload));
    }).then(function (ids) {
      return api('POST', cpath('/messages'), { text: lm.text, attachmentIds: ids });
    }).then(function (r) {
      var i = local.indexOf(lm);
      if (i >= 0) local.splice(i, 1);
      addMsgs([r.message]);
      draw();
    }, function (e) {
      if (e.contact && !st.id) {
        delete st.contact;
        save();
        regate(lm, T.err.contact);
        return;
      }
      lm.status = 'failed';
      draw();
      flash(errText(e));
      if (e.code === 'invalid_token') expire();
      else if (e.code === 'conversation_closed') refresh().catch(noop);
    });
  }

  /* Gegevensstap voor het eerste bericht: het bericht wacht in pend, de composer is zolang dicht. */
  function openGate(text, msg) {
    pend = pend == null ? text : [pend, text].join('\n\n').trim();
    P.ta.value = '';
    grow();
    P.qt.textContent = '';
    kids(P.qt, el('strong', null, T.question), document.createTextNode(' ' + pend));
    P.quote.hidden = !pend;
    P.gerr.textContent = msg || '';
    P.gerr.hidden = !msg;
    P.gate.hidden = false;
    P.body.inert = P.foot.inert = P.ta.disabled = true;
    updateSend();
    gateFocus(!!msg);
  }

  function gateFocus(first) {
    var f = first ? FIELDS[0] : FIELDS.filter(function (x) { return !x.opt && !P.f[x.k].in.value.trim(); })[0];
    (f ? P.f[f.k].in : P.go).focus();
  }

  function closeGate(back) {
    var text = pend;
    if (text == null) return;
    pend = null;
    P.gate.hidden = true;
    P.body.inert = P.foot.inert = P.ta.disabled = false;
    if (back) { P.ta.value = text; grow(); }
    updateSend();
    return text;
  }

  function startChat() {
    if (pend == null || !takeContact()) return;
    post(closeGate());
    P.ta.focus();
  }

  /* Niet aangekomen eerste bericht terug naar de gegevensstap; bijlagen weer in de composer. */
  function regate(lm, msg) {
    var i = local.indexOf(lm);
    if (i >= 0) local.splice(i, 1);
    files = lm.files.concat(files);
    drawFiles();
    draw();
    openGate(lm.text, msg);
  }

  function endConv() {
    toggleMenu(false);
    if (!st.id) return;
    api('POST', cpath('/close')).then(function (r) { merge(r.conversation); }, function (e) {
      if (e.code === 'conversation_closed') refresh().catch(noop);
      else flash(errText(e));
    });
  }

  function addFiles(list) {
    list = [].slice.call(list || []);
    for (var i = 0; i < list.length; i++) {
      var f = list[i];
      if (files.length >= MAX_FILES) { flash(T.err.too_many); break; }
      if (!okType(f)) { flash(T.err.unsupported_type); continue; }
      if (f.size > MAX_SIZE) { flash(T.err.file_too_large); continue; }
      var a = { file: f, url: URL.createObjectURL(SAFE.test(f.type) ? f : new Blob([f], { type: 'application/pdf' })), pct: 0, bars: [] };
      files.push(a);
      if (st.id) upload(a).catch(function (e) { if (e.code !== 'aborted') { flash(errText(e)); drawFiles(); } });
    }
    drawFiles();
    updateSend();
  }

  function prog(a, v) {
    a.pct = v;
    a.bars = a.bars.filter(function (b) { return b.isConnected; });
    a.bars.forEach(function (b) {
      b.firstChild.style.width = Math.round(v * 100) + '%';
      b.parentNode.classList.toggle('nc-done', v >= 1);
    });
  }
  function bar(a, host) {
    var b = kids(el('span', 'nc-prog'), el('i'));
    a.bars.push(b);
    host.appendChild(b);
    b.firstChild.style.width = Math.round(a.pct * 100) + '%';
    if (a.id) host.classList.add('nc-done');
  }

  /* ---------- panel ---------- */

  function build() {
    if (P) return;
    P = {};
    var panel = P.panel = at(el('div', 'nc-panel'), { id: 'nc-panel', role: 'dialog', 'aria-label': T.launch });
    panel.hidden = true;

    var more = P.more = at(btn('nc-ib', T.more, I.more), { 'aria-haspopup': 'true', 'aria-expanded': 'false' });
    var menu = P.menu = at(el('div', 'nc-menu'), { role: 'menu' });
    var endB = at(btn('nc-mi', null, I.end), { role: 'menuitem' });
    endB.appendChild(el('span', null, T.end));
    menu.appendChild(endB);
    menu.hidden = true;
    var x = P.close = btn('nc-ib', T.close, I.x);
    var head = kids(el('div', 'nc-head'),
      av('nc-av-h'),
      kids(el('div', 'nc-ht'), el('div', 'nc-title', T.team), kids(el('div', 'nc-sub'), el('i', 'nc-dot'), el('span', null, T.sub))),
      kids(el('div', 'nc-ha'), more, x, menu));

    var body = P.body = el('div', 'nc-body');
    P.log = at(el('div', 'nc-log'), { role: 'log', 'aria-live': 'polite', 'aria-relevant': 'additions' });
    P.typ = at(kids(el('div', 'nc-row nc-team nc-typ'), av('nc-av-s'), kids(el('div', 'nc-col'), kids(el('div', 'nc-bub nc-tbub'), el('i'), el('i'), el('i')))), { 'aria-hidden': 'true' });
    P.typ.hidden = true;
    P.tsr = at(el('div', 'nc-sr'), { role: 'status', 'aria-live': 'polite' });
    kids(body, buildWelcome(), P.log, buildAway(), P.tsr);

    P.err = at(el('div', 'nc-err'), { role: 'alert' });
    P.err.hidden = true;
    P.files = el('div', 'nc-files');
    P.ta = at(el('textarea', 'nc-ta'), { rows: '1', maxlength: '4000', placeholder: T.ph, 'aria-label': T.ph, enterkeyhint: 'send' });
    var clip = btn('nc-ib nc-clip', T.attach, I.clip);
    P.send = btn('nc-send', T.send, I.send);
    P.fileIn = at(el('input'), { type: 'file', accept: ACCEPT, multiple: '', tabindex: '-1', 'aria-hidden': 'true' });
    P.fileIn.hidden = true;
    P.hp = at(el('input', 'nc-hp'), { type: 'text', name: 'website', tabindex: '-1', autocomplete: 'off', 'aria-hidden': 'true' });
    P.hint = el('p', 'nc-hint', T.orderHint);
    P.hint.hidden = true;
    P.compose = kids(el('div', 'nc-compose'), P.files, kids(el('div', 'nc-field'), clip, P.ta, P.send), P.hint, P.fileIn, P.hp);
    var restart = el('button', 'nc-cta', T.restart);
    restart.type = 'button';
    P.closed = kids(el('div', 'nc-closed'), el('p', 'nc-closed-t', T.closed), restart);
    P.foot = kids(el('div', 'nc-foot'), P.err, P.compose, P.closed);
    kids(panel, head, kids(el('div', 'nc-main'), body, P.foot, buildGate()));
    root.appendChild(panel);

    x.onclick = function () { closePanel(); };
    more.onclick = function () { toggleMenu(menu.hidden); };
    endB.onclick = endConv;
    restart.onclick = function () { reset(); P.ta.focus(); };
    clip.onclick = function () { P.fileIn.click(); };
    P.fileIn.onchange = function () { addFiles(P.fileIn.files); P.fileIn.value = ''; };
    P.send.onclick = send;
    P.ta.oninput = function () { grow(); updateSend(); };
    P.ta.onkeydown = function (e) {
      if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); send(); }
    };
    P.ta.onpaste = function (e) {
      var f = e.clipboardData && e.clipboardData.files;
      if (f && f.length) { e.preventDefault(); addFiles(f); }
    };
    panel.ondragover = function (e) { if (!P.compose.hidden && pend == null) e.preventDefault(); };
    panel.ondrop = function (e) {
      if (P.compose.hidden || pend != null || !e.dataTransfer) return;
      e.preventDefault();
      addFiles(e.dataTransfer.files);
    };
    panel.onkeydown = function (e) {
      if (e.key !== 'Escape') return;
      e.stopPropagation();
      if (pend != null) { closeGate(true); P.ta.focus(); } else if (!menu.hidden) { toggleMenu(false); more.focus(); } else closePanel();
    };
    document.addEventListener('click', function (e) {
      if (!menu.hidden && !menu.contains(e.target) && !more.contains(e.target)) toggleMenu(false);
    }, true);
    prefill();
    updateSend();
  }

  function buildWelcome() {
    var t = T.topics, p = cfg.product && cfg.product.title;
    var w = P.welcome = el('div', 'nc-welcome');
    var list = el('div', 'nc-topics');
    P.chips = [];
    [['order_status', t[0]], ['product_question', p ? t[2].replace('{p}', p) : t[1]], ['product_info', t[3]], ['returns', t[4]], ['other', t[5]]]
      .forEach(function (it) {
        var b = at(btn('nc-topic'), { 'aria-pressed': 'false', 'data-topic': it[0] });
        kids(b, el('span', null, it[1]), ico(I.arrow));
        b.onclick = function () { pickTopic(it[0], it[1]); };
        P.chips.push(b);
        list.appendChild(b);
      });

    return kids(w, av('nc-av-l'), el('p', 'nc-hello', T.hello), el('p', 'nc-hsub', T.helloSub), list);
  }

  function buildGate() {
    var gate = P.gate = el('div', 'nc-gate');
    var sheet = at(el('div', 'nc-sheet'), { role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'nc-gate-t' });
    var names = el('div', 'nc-frow');
    var go = P.go = el('button', 'nc-cta', T.start);
    var back = el('button', 'nc-alink', T.back);
    go.type = back.type = 'button';
    P.qt = el('p', 'nc-qt');
    P.quote = kids(el('div', 'nc-quote'), P.qt);
    P.gerr = at(el('p', 'nc-err'), { role: 'alert' });
    P.gerr.hidden = gate.hidden = true;
    P.f = {};
    P.ohint = at(el('p', 'nc-fhint', T.orderHint), { id: 'nc-ohint' });
    P.ohint.hidden = true;
    kids(sheet, P.quote, at(el('p', 'nc-gtitle', T.gate), { id: 'nc-gate-t' }), P.gerr, names);
    FIELDS.forEach(function (f, i) {
      var id = 'nc-f-' + f.k;
      var inp = at(el('input', 'nc-in'), { id: id, type: f.type || 'text', name: f.opt ? 'order-number' : f.ac, autocomplete: f.ac, maxlength: String(f.max), enterkeyhint: FIELDS[i + 1] ? 'next' : 'go' });
      if (f.type === 'email') at(inp, { inputmode: 'email', autocapitalize: 'off', spellcheck: 'false' });
      if (!f.opt) inp.setAttribute('aria-required', 'true');
      var lab = kids(at(el('label', 'nc-lab', T[f.k]), { 'for': id }),
        f.opt ? el('span', 'nc-opt', ' ' + T.optional) : at(el('span', 'nc-req', '*'), { 'aria-hidden': 'true' }));
      var e = at(el('p', 'nc-ferr'), { id: id + '-e' });
      e.hidden = true;
      P.f[f.k] = { in: inp, err: e };
      kids(i < 2 ? names : sheet, kids(el('div', 'nc-fld'), lab, inp, e, f.opt && P.ohint));
      inp.oninput = function () { if (inp.hasAttribute('aria-invalid')) fieldErr(f.k, ''); };
      inp.onkeydown = function (ev) {
        if (ev.key !== 'Enter' || ev.isComposing) return;
        ev.preventDefault();
        if (FIELDS[i + 1]) P.f[FIELDS[i + 1].k].in.focus(); else startChat();
      };
    });
    kids(sheet, kids(el('div', 'nc-gact'), go, back));
    go.onclick = startChat;
    back.onclick = function () { closeGate(true); P.ta.focus(); };
    gate.onkeydown = function (e) {
      if (e.key !== 'Tab') return;
      var list = [].slice.call(sheet.querySelectorAll('input, button')), i = list.indexOf(document.activeElement);
      if (e.shiftKey ? i <= 0 : i === list.length - 1) { e.preventDefault(); list[e.shiftKey ? list.length - 1 : 0].focus(); }
    };
    return kids(gate, sheet);
  }

  function fieldErr(k, msg) {
    var f = P.f[k];
    f.err.textContent = msg;
    f.err.hidden = !msg;
    if (msg) f.in.setAttribute('aria-invalid', 'true'); else f.in.removeAttribute('aria-invalid');
    describe(k);
  }
  function describe(k) {
    var f = P.f[k], ids = [];
    if (!f.err.hidden) ids.push(f.err.id);
    if (k === 'orderNumber' && !P.ohint.hidden) ids.push(P.ohint.id);
    if (ids.length) f.in.setAttribute('aria-describedby', ids.join(' ')); else f.in.removeAttribute('aria-describedby');
  }
  function formOn() { return !st.id && !creating && !(conv && conv.state === 'closed') && !known(); }

  function buildAway() {
    var box = P.away = el('div', 'nc-away');
    var form = P.aform = el('form', 'nc-aform');
    var inp = P.awayIn = at(el('input', 'nc-in'), { type: 'email', autocomplete: 'email', maxlength: '254', inputmode: 'email', required: '', 'aria-label': T.email, placeholder: T.email });
    var sb = el('button', 'nc-cta', T.save);
    sb.type = 'submit';
    var other = P.aother = at(el('button', 'nc-alink', T.otherMail), { type: 'button' });
    P.atext = el('p', 'nc-atext');
    kids(box, kids(el('div', 'nc-ahead'), kids(el('span', 'nc-aico'), ico(I.mail)), kids(el('div', 'nc-acol'), P.atext, other)), kids(form, inp, sb));
    box.hidden = true;
    other.onclick = function () {
      other.hidden = true;
      form.hidden = false;
      inp.focus();
      inp.select();
    };
    form.setAttribute('novalidate', '');
    form.onsubmit = function (e) {
      e.preventDefault();
      var v = inp.value.trim();
      if (!okMail(v)) { flash(T.err.bad_email); inp.focus(); return; }
      if (OWN.test(v)) { flash(T.err.own_email); inp.focus(); return; }
      var c = st.contact || {}, body = { email: v };
      var nm = [c.firstName, c.lastName].join(' ').trim() || c.name || (cfg.customer && cfg.customer.name);
      if (nm) body.name = String(nm).slice(0, 80);
      sb.disabled = true;
      api('POST', cpath('/contact'), body).then(function (r) {
        c.email = v;
        st.contact = c;
        save();
        merge(r.conversation);
      }, function (er) { flash(errText(er)); }).then(function () { sb.disabled = false; });
    };
    return box;
  }

  /* Oudere opslag en de klantnaam hebben alleen een volledige naam: eerste woord is de voornaam. */
  function split(n) {
    n = String(n || '').trim();
    var i = n.indexOf(' ');
    return i < 0 ? [n, ''] : [n.slice(0, i), n.slice(i + 1).trim()];
  }

  function prefill() {
    var c = st.contact || {}, k = cfg.customer || {}, n = split(c.name || k.name);
    var v = {
      firstName: c.firstName || k.firstName || n[0],
      lastName: c.lastName || k.lastName || n[1],
      email: c.email || k.email,
      orderNumber: c.orderNumber
    };
    FIELDS.forEach(function (f) {
      P.f[f.k].in.value = String(v[f.k] || '').trim().slice(0, f.max);
      fieldErr(f.k, '');
    });
  }

  function knownMail() {
    var c = st.contact || {};
    var v = String((conv && conv.contact && conv.contact.email) || c.email || '').trim();
    /* De backend weigert eigen adressen als contactadres. */
    return OWN.test(v) ? '' : v;
  }

  function fillAway() {
    var v = knownMail(), k = cfg.customer || {};
    P.atext.textContent = '';
    if (v) {
      var p = T.awayKnown.split('{email}');
      kids(P.atext, document.createTextNode(p[0]), el('strong', 'nc-amail', v), document.createTextNode(p[1] || ''));
    } else P.atext.textContent = T.away;
    P.aother.hidden = !v;
    P.aform.hidden = !!v;
    var aw = v || String(k.email || '').trim();
    P.awayIn.value = OWN.test(aw) ? '' : aw;
  }

  function pickTopic(code, text) {
    topic = code;
    P.chips.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-topic') === code)); });
    var order = code === 'order_status', form = formOn();
    P.ohint.hidden = !order;
    P.hint.hidden = !order || form;
    describe('orderNumber');
    if (!code) return;
    P.ta.value = text + ' ';
    grow();
    updateSend();
    P.ta.focus();
    P.ta.setSelectionRange(P.ta.value.length, P.ta.value.length);
  }

  function toggleMenu(open) {
    if (!P) return;
    P.menu.hidden = !open;
    P.more.setAttribute('aria-expanded', String(open));
    if (open) P.menu.firstChild.focus();
  }

  function grow() {
    var t = P.ta;
    t.style.height = 'auto';
    t.style.height = Math.min(t.scrollHeight, 132) + 'px';
  }
  function updateSend() { if (P) P.send.disabled = pend != null || !(P.ta.value.trim() || files.length); }

  function flash(msg) {
    if (!P) return;
    P.err.textContent = msg;
    P.err.hidden = false;
    clearTimeout(flashT);
    flashT = setTimeout(function () { P.err.hidden = true; }, 7000);
  }

  function openPanel(quiet) {
    build();
    if (isOpen) return;
    isOpen = true;
    root.classList.add('nc-open');
    document.documentElement.classList.add('nc-chat-open');
    P0.btn.setAttribute('aria-expanded', 'true');
    P.panel.hidden = false;
    fitViewport();
    void P.panel.offsetWidth;
    P.panel.classList.add('nc-on');
    if (mq.matches) document.documentElement.style.overflow = 'hidden';
    st.open = true;
    save();
    country();
    markSeen();
    render();
    if (!P.log.hidden) scrollEnd();
    if (quiet) return;
    if (pend != null) gateFocus();
    else if (!mq.matches) P.ta.focus();
    else P.close.focus();
  }

  function closePanel() {
    if (!isOpen) return;
    isOpen = false;
    fitViewport();
    var inside = P.panel.contains(document.activeElement);
    closeGate(true);
    toggleMenu(false);
    root.classList.remove('nc-open');
    document.documentElement.classList.remove('nc-chat-open');
    P0.btn.setAttribute('aria-expanded', 'false');
    P.panel.classList.remove('nc-on');
    setTimeout(function () { if (!isOpen) P.panel.hidden = true; }, 240);
    document.documentElement.style.overflow = '';
    st.open = false;
    save();
    if (inside) P0.btn.focus();
  }

  /* ---------- rendering ---------- */

  function draw() {
    if (!P || drawQ) return;
    drawQ = requestAnimationFrame(function () { drawQ = 0; render(); });
  }

  function visible(m) { return !(m.author === 'system' && (m.systemCode === 'away' || m.systemCode === 'closed')); }

  function render() {
    if (!P) return;
    var s = conv && conv.state, closed = s === 'closed';
    ackDue(s);
    var all = withAcks(msgs.filter(visible)).concat(local);
    P.welcome.hidden = all.length > 0;
    P.log.hidden = !all.length;
    drawLog(all);
    drawAway(s);
    drawTyping(s);
    P.compose.hidden = closed;
    P.closed.hidden = !closed;
    P.more.hidden = !st.id || closed;
    updateSend();
  }

  /* Eerste klantbericht van de lopende beurt (sinds het laatste teambericht), of null. */
  function turn() {
    var f = null;
    msgs.forEach(function (m) { if (m.author === 'team') f = null; else if (m.author === 'customer' && !f) f = m; });
    return f;
  }
  function ackOf(k) { return acks.filter(function (a) { return a.k === k; })[0]; }

  /* Bevestiging zodra de beurt ACK_MS onbeantwoord is; createdAt in de toekomst (scheve klok) telt vanaf ontvangst. */
  function ackDue(s) {
    var f = turn(), c = f ? Date.parse(f.createdAt) : NaN;
    if (isNaN(c) || s === 'closed' || ackOf(f.id)) return;
    var wait = Math.min(c, f.rx || c) + ACK_MS - Date.now();
    if (wait > 0) {
      if (!ackT) ackT = setTimeout(function () { ackT = 0; draw(); }, wait);
      return;
    }
    acks.push({ k: f.id, t: new Date(c + ACK_MS).toISOString(), l: lang() });
    acks.splice(0, acks.length - 20);
    st.acks = acks;
    save();
    stopTyping();
  }

  /* Na het klantbericht en de berichten tot t; vervalt als het team binnen die tijd al antwoordde. */
  function withAcks(list) {
    acks.forEach(function (a) {
      var i = list.indexOf(byId[a.k]), t = Date.parse(a.t);
      if (i < 0 || !ACK[a.l]) return;
      while (++i < list.length && !(Date.parse(list[i].createdAt) > t)) if (list[i].author === 'team' && !list[i].ack) return;
      list.splice(i, 0, { id: 'ack-' + a.k, author: 'team', authorName: T.team, text: ACK[a.l], createdAt: a.t, ack: true });
    });
    return list;
  }

  function keyOf(m) { return m.id || 'l' + m.n + m.status; }

  function drawLog(all) {
    var i = 0, near = !shown.length || nearEnd(), added = false;
    while (i < shown.length && i < all.length && shown[i].k === keyOf(all[i])) i++;
    shown.splice(i).forEach(function (s) { s.node.remove(); });
    for (; i < all.length; i++) {
      var node = item(all[i], all[i - 1]);
      P.log.appendChild(node);
      shown.push({ k: keyOf(all[i]), node: node });
      added = true;
    }
    if (added && (near || all[all.length - 1].author === 'customer')) scrollEnd();
  }

  function drawAway(s) {
    var la = -1, lc = -1, ls = -1;
    msgs.forEach(function (m, i) {
      if (m.author === 'customer') lc = i;
      else if (m.systemCode === 'away') la = i;
      else if (m.systemCode === 'contact_saved') ls = i;
    });
    var show = !!st.id && s !== 'closed' && (s === 'away' || la > lc) && ls <= la;
    if (show && P.away.hidden) {
      fillAway();
      P.away.hidden = false;
      if (nearEnd(160)) scrollEnd();
    } else if (!show) P.away.hidden = true;
  }

  function rnd(a, b) { return a + Math.random() * (b - a); }

  /* Typpuntjes zolang het laatste bevestigde bericht van de klant is; de indicator staat altijd als laatste in het log. */
  function drawTyping(s) {
    if (P.log.lastChild !== P.typ) P.log.appendChild(P.typ);
    var v = msgs.filter(visible), m = v[v.length - 1];
    var due = !!st.id && s === 'open' && pend == null && P.away.hidden && m && m.author === 'customer' &&
      !local.some(function (l) { return l.status === 'failed' || l.status === 'sending'; });
    if (!due) return stopTyping();
    if (typT) return;
    /* Vanaf het laatste klantbericht of de bevestiging van deze beurt; afgekapt, want een achterlopende klok zou anders lang laten wachten. */
    var f = turn(), a = f && ackOf(f.id);
    var t = Math.max(Date.parse(m.createdAt) || Date.now(), (a && Date.parse(a.t)) || 0);
    typT = setTimeout(function () { typeStep(true); }, Math.min(5000, t + rnd(2000, 5000) - Date.now()));
  }

  function typeStep(on) {
    var t = P.typ;
    /* In een pauze vervaagt alleen de bubbel; de rij houdt zijn plek, zodat het log niet verspringt. */
    if (on && t.hidden) {
      var near = nearEnd();
      t.hidden = false;
      void t.offsetWidth;
      if (near) scrollEnd();
      P.tsr.textContent = T.typing;
    }
    t.classList.toggle('nc-on', on);
    typT = setTimeout(function () { typeStep(!on); }, on ? rnd(1800, 6500) : Math.random() < .25 ? rnd(2500, 5000) : rnd(600, 2200));
  }

  function stopTyping() {
    clearTimeout(typT);
    typT = 0;
    if (!P) return;
    P.typ.classList.remove('nc-on');
    P.typ.hidden = true;
    P.tsr.textContent = '';
  }

  function nearEnd(px) {
    var b = P.body;
    return b.scrollHeight - b.scrollTop - b.clientHeight < (px || 80);
  }
  function scrollEnd() { P.body.scrollTop = P.body.scrollHeight; }

  function item(m, prev) {
    var wrap = el('div', 'nc-item'), d = new Date(m.createdAt), pd = prev && new Date(prev.createdAt);
    if (isNaN(d)) d = new Date();
    var newDay = !prev || dayKey(d) !== dayKey(pd);
    if (newDay) wrap.appendChild(kids(el('div', 'nc-day'), el('span', null, dayLabel(d))));
    if (m.author === 'system') {
      wrap.appendChild(kids(el('div', 'nc-sys'), el('span', null, T.sys[m.systemCode] || m.text || '')));
      return wrap;
    }
    var me = m.author === 'customer';
    var grp = !newDay && prev.author === m.author && (prev.authorName || '') === (m.authorName || '') && d - pd < 300000;
    var row = el('div', 'nc-row ' + (me ? 'nc-me' : 'nc-team') + (grp ? ' nc-grp' : ''));
    if (!me) row.appendChild(grp ? el('span', 'nc-avsp') : av('nc-av-s'));
    var col = el('div', 'nc-col');
    if (!me && !grp) col.appendChild(el('div', 'nc-who', m.authorName || T.team));
    if (m.text) col.appendChild(linkify(el('div', 'nc-bub'), m.text));
    var atts = m.files || m.attachments || [];
    if (atts.length) col.appendChild(attList(atts, !!m.files));
    var meta = el('div', 'nc-meta', m.status === 'sending' ? T.sending : hhmm(d));
    if (m.status === 'failed') {
      meta.className += ' nc-fail';
      meta.textContent = T.failed + ' · ';
      var r = el('button', 'nc-retry', T.retry);
      r.type = 'button';
      r.onclick = function () { if (st.id || creating || known()) deliver(m); else regate(m); };
      meta.appendChild(r);
    }
    col.appendChild(meta);
    row.appendChild(col);
    wrap.appendChild(row);
    return wrap;
  }

  function attList(atts, isLocal) {
    var box = el('div', 'nc-atts');
    atts.forEach(function (a) {
      var name = isLocal ? a.file.name : a.name || '', type = isLocal ? a.file.type : a.contentType, size = isLocal ? a.file.size : a.size;
      if (IMG.test(type)) {
        var b = at(btn('nc-thumb'), { 'aria-label': T.open + ': ' + name }), img = at(el('img'), { alt: name });
        b.appendChild(img);
        if (isLocal) { img.src = a.url; bar(a, b); } else blobOf(a).then(function (u) { img.src = u; }, function () { b.classList.add('nc-bad'); });
        img.onload = function () { if (nearEnd(200)) scrollEnd(); };
        b.onclick = function () { var u = img.getAttribute('src'); if (u) lightbox(u, name); };
        box.appendChild(b);
        return;
      }
      var c = at(el('a', 'nc-chip'), { href: '#', rel: 'noopener', target: '_blank' });
      if (type !== 'application/pdf') c.setAttribute('download', name);
      kids(c, ico(I.file), kids(el('span', 'nc-cn'), el('span', 'nc-cname', name), el('span', 'nc-csize', fmtSize(size || 0))));
      if (isLocal) { c.href = a.url; bar(a, c); } else {
        c.onclick = function (e) {
          if (c.getAttribute('data-ready')) return;
          e.preventDefault();
          blobOf(a).then(function (u) { c.href = u; c.setAttribute('data-ready', '1'); c.click(); }, function (er) { flash(errText(er)); });
        };
      }
      box.appendChild(c);
    });
    return box;
  }

  function drawFiles() {
    if (!P) return;
    P.files.textContent = '';
    P.files.hidden = !files.length;
    files.forEach(function (a) {
      var t = el('div', 'nc-pv' + (IMG.test(a.file.type) ? '' : ' nc-pvf'));
      if (IMG.test(a.file.type)) t.appendChild(at(el('img'), { src: a.url, alt: '' }));
      else kids(t, ico(I.file), el('span', 'nc-pvn', a.file.name));
      var rm = btn('nc-pvx', T.remove + ': ' + a.file.name, I.x);
      rm.onclick = function () {
        if (a.xhr) a.xhr.abort();
        files.splice(files.indexOf(a), 1);
        if (!a.id) URL.revokeObjectURL(a.url);
        drawFiles();
        updateSend();
        P.ta.focus();
      };
      t.appendChild(rm);
      if (a.p || a.id) bar(a, t);
      P.files.appendChild(t);
    });
  }

  function lightbox(src, name) {
    var back = document.activeElement;
    var lb = at(el('div', 'nc-lb'), { role: 'dialog', 'aria-modal': 'true', 'aria-label': name });
    var img = at(el('img'), { src: src, alt: name });
    var x = btn('nc-lbx', T.lbClose, I.x);
    kids(lb, img, x);
    function done() { lb.remove(); if (back && back.focus) back.focus(); }
    lb.onclick = function (e) { if (e.target !== img) done(); };
    lb.onkeydown = function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); done(); }
      if (e.key === 'Tab') { e.preventDefault(); x.focus(); }
    };
    root.appendChild(lb);
    x.focus();
  }

  /* iOS keeps the layout viewport tall while the keyboard covers its bottom.
     Keep the mobile panel inside the visual viewport, including Safari panning. */
  function fitViewport() {
    if (!P) return;
    var v = window.visualViewport;
    if (isOpen && mq.matches && v) {
      P.panel.style.top = v.offsetTop + 'px';
      P.panel.style.height = v.height + 'px';
      P.panel.style.bottom = 'auto';
    } else {
      P.panel.style.top = '';
      P.panel.style.height = '';
      P.panel.style.bottom = '';
    }
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fitViewport);
    window.visualViewport.addEventListener('scroll', fitViewport);
  }
  window.addEventListener('resize', fitViewport);

  /* ---------- launcher + lift above bottom bars ---------- */

  var P0 = {};

  function launcher() {
    var b = P0.btn = at(btn('nc-launch', T.launch), { 'aria-expanded': 'false', 'aria-controls': 'nc-panel' });
    var s = at(document.createElementNS(NS, 'svg'), { viewBox: '0 0 32 32', 'aria-hidden': 'true', focusable: 'false', 'class': 'nc-bubble' });
    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', BUBBLE);
    kids(s, p, logo({ 'class': 'nc-n', transform: 'translate(11.9 9.5) scale(0.038)' }));
    P0.badge = at(el('span', 'nc-badge'), { 'aria-hidden': 'true' });
    kids(b, s, ico(I.x, 'nc-lx'), P0.badge);
    b.onclick = function () { if (isOpen) closePanel(); else openPanel(); };
    root.appendChild(b);
  }

  var lifters = [];
  var liftQ = 0;
  var liftT = 0;
  function findLifters() {
    lifters = [].slice.call(document.querySelectorAll('.prod__sticky-atc, .footer-mobile__common, #shopify-pc__banner'));
    lift();
  }
  function lift() {
    liftQ = 0;
    var h = 0, W = window.innerWidth, H = window.innerHeight;
    lifters.forEach(function (n) {
      var r = n.getBoundingClientRect();
      if (r.width > W / 2 && r.height > 0 && r.top < H && r.bottom >= H - 2) h = Math.max(h, H - r.top);
    });
    root.style.setProperty('--nc-lift', Math.round(h) + 'px');
  }
  function onScroll() {
    if (!lifters.length) return;
    if (!liftQ) liftQ = requestAnimationFrame(lift);
    clearTimeout(liftT);
    liftT = setTimeout(lift, 400);
  }

  /* ---------- start ---------- */

  launcher();
  badge();
  if (cfg.cssUrl) {
    var link = at(el('link'), { rel: 'stylesheet', href: cfg.cssUrl });
    link.onload = function () { root.hidden = false; };
    document.head.appendChild(link);
  } else root.hidden = false;

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stopLive(); return; }
    if (isOpen) markSeen();
    if (st.id) live();
  });

  (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(function () {
    findLifters();
    setTimeout(findLifters, 3000);
    var ready = st.id ? refresh().then(live, function (e) { if (st.id) retry(e); }) : Promise.resolve();
    if (st.open) ready.then(function () { openPanel(true); });
  }, { timeout: 2000 });
})();
